<template>
  <div class="hashtag-page">
    <Header class="media-query-pc" />
    <MediaHeader class="media-query-m" />

    <div class="hashtag-wrap">
      <main class="main">
        <section class="hero">
          <div class="mark">#</div>
          <div class="hero-content">
            <h1>{{ title }}</h1>
            <p v-if="detail.content">{{ detail.content }}</p>
            <div class="stats">
              <span>浏览 {{ detail.view || 0 }}</span>
              <span>内容 {{ itemTotal || 0 }}</span>
            </div>
          </div>
          <a v-if="detail.closed != 1" class="publish" :href="publishUrl | hostBuild('forum')" target="_blank">
            参与话题
          </a>
        </section>

        <section class="post-list">
          <template v-for="(item, index) in list">
            <YorkbbsInfoflowItem v-if="item.app === 'crm_ad'" :key="'ad-' + index" :data="item" />
            <SubjectCmsItem v-else-if="item.app === 'cms_post'" :key="item.id" :data="item" />
            <SubjectPostItem v-else-if="item.app === 'bbs_post'" :key="item.id" :data="item" @attention="attention" />
          </template>

          <div v-if="pageComplete && list.length === 0" class="empty">
            <div class="empty-mark">#</div>
            <div>暂无相关内容</div>
          </div>

          <div v-if="hasMore && listLoading" class="loading"><i class="el-icon-loading"></i> 加载中</div>
          <div v-if="pageComplete && !hasMore && list.length > 0" class="loading">没有更多了</div>
        </section>
      </main>

      <aside class="side">
        <HotSubject />
      </aside>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header/header.vue';
import MediaHeader from '@/components/header/media-header.vue';
import HotSubject from '@/views/discussion/hot-subject.vue';
import SubjectCmsItem from '@/views/discussion/subject-cms-item.vue';
import SubjectPostItem from '@/views/discussion/subject-post-item.vue';
import YorkbbsInfoflowItem from '@/components/item-infoflow.vue';
import { inflowAdvConvert, isScrollToPageBottom, setHtmlMeta } from '@/utils/utils';
import { throttle } from 'throttle-debounce';

export default {
  name: 'HashtagPage',
  components: {
    Header,
    MediaHeader,
    HotSubject,
    SubjectCmsItem,
    SubjectPostItem,
    YorkbbsInfoflowItem,
  },
  data() {
    return {
      detail: {
        id: '',
        title: '',
        content: '',
        closed: 0,
        view: 0,
        postCount: 0,
      },
      params: {
        name: '',
        offset: 1,
        size: 10,
      },
      type: 2,
      list: [],
      itemTotal: 0,
      pageComplete: false,
      hasMore: true,
      listLoading: false,
    };
  },
  computed: {
    title() {
      return this.detail.title || this.params.name;
    },
    publishUrl() {
      return `/micro/chat?hashtag=${encodeURIComponent(this.title || this.params.name)}`;
    },
  },
  watch: {
    '$route.params.name': {
      immediate: true,
      handler() {
        this.params.name = this.normalizeName(this.$route.params.name);
        this.resetPage();
        this.getDetail();
        this.getList();
      },
    },
  },
  mounted() {
    window.addEventListener('scroll', this.pageScroll);
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('scroll', this.pageScroll);
    });
  },
  methods: {
    normalizeName(name) {
      return decodeURIComponent(name || '').replace(/^#+/, '').trim();
    },
    resetPage() {
      this.params.offset = 1;
      this.list = [];
      this.itemTotal = 0;
      this.pageComplete = false;
      this.hasMore = true;
    },
    async getDetail() {
      const result = await this.$axios.post('/subject/v1/hashtag/get/detail', { name: this.params.name });
      if (result.code === 0) {
        this.detail = {
          ...this.detail,
          ...result.data.subject,
        };
        setHtmlMeta({
          title: `#${this.title} - 约克论坛`,
          keywords: `${this.title},约克论坛,多伦多话题`,
          description: this.detail.content || `约克论坛关于${this.title}的话题内容。`,
        });
      }
    },
    async getList() {
      if (this.listLoading || !this.params.name) return;
      this.listLoading = true;
      const result = await this.$axios.post('/subject/v1/hashtag/post/list', {
        name: this.params.name,
        type: this.type,
        offset: this.params.offset,
        size: this.params.size,
      });

      if (result.code === 0) {
        const items = result.data.items || [];
        this.itemTotal = result.data.itemTotal || 0;
        this.list = this.list.concat(inflowAdvConvert(items, 'subject', this.detail.id || this.params.name));
        this.hasMore = this.list.length < this.itemTotal;
      } else {
        this.hasMore = false;
      }

      this.pageComplete = true;
      this.listLoading = false;
    },
    pageScroll: throttle(300, function () {
      if (isScrollToPageBottom() && this.pageComplete && this.hasMore && !this.listLoading) {
        this.params.offset += 1;
        this.getList();
      }
    }),
    attention(obj) {
      this.list.forEach(item => {
        if (item.app === 'bbs_post' && item.user.id === obj.id) {
          item.user.focusedByMe = obj.val;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.hashtag-wrap {
  display: flex;
  width: 990px;
  margin: 30px auto 0;

  .main {
    flex: 1;
    overflow: hidden;
  }

  .side {
    width: 300px;
    margin-left: 40px;
  }
}

.hero {
  display: flex;
  align-items: center;
  padding: 26px 28px;
  margin-bottom: 24px;
  background: #f8f8f8;
  border-radius: 10px;

  .mark {
    width: 42px;
    height: 42px;
    margin-right: 16px;
    border-radius: 50%;
    background: #e43a3a;
    color: #fff;
    font-size: 26px;
    line-height: 42px;
    text-align: center;
    font-weight: 700;
  }

  .hero-content {
    flex: 1;
    min-width: 0;

    h1 {
      margin: 0 0 8px;
      font-size: 28px;
      line-height: 36px;
      color: #111;
    }

    p {
      margin: 0 0 12px;
      color: #666;
      font-size: 14px;
      line-height: 24px;
    }
  }

  .stats {
    display: flex;
    color: #999;
    font-size: 13px;

    span {
      margin-right: 18px;
    }
  }

  .publish {
    display: flex;
    align-items: center;
    height: 36px;
    padding: 0 14px;
    border-radius: 4px;
    background: #e43a3a;
    color: #fff;
    font-size: 14px;
    white-space: nowrap;

    &:hover {
      opacity: 0.85;
    }
  }
}

.empty {
  padding: 80px 0;
  color: #999;
  text-align: center;
  font-size: 15px;

  .empty-mark {
    display: inline-block;
    width: 42px;
    height: 42px;
    margin-bottom: 12px;
    border-radius: 50%;
    background: #f1f1f1;
    color: #bbb;
    line-height: 42px;
    font-size: 24px;
  }
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  color: #999;
  font-size: 12px;

  i {
    margin-right: 5px;
  }
}

@media screen and (max-width: 768px) {
  .hashtag-page {
    padding-top: 50px;
  }

  .hashtag-wrap {
    display: block;
    width: 100%;
    margin-top: 0;

    .main {
      width: 100%;
    }

    .side {
      display: none;
    }
  }

  .hero {
    margin-bottom: 14px;
    padding: 20px 15px;
    border-radius: 0;

    .mark {
      width: 34px;
      height: 34px;
      margin-right: 12px;
      line-height: 34px;
      font-size: 20px;
    }

    .hero-content {
      h1 {
        font-size: 22px;
        line-height: 30px;
      }
    }

    .publish {
      display: none;
    }
  }

  .post-list {
    margin: 0 15px;
  }

  .media-query-pc {
    display: none;
  }

  .media-query-m {
    display: block;
  }
}

@media screen and (min-width: 768px) {
  .media-query-pc {
    display: block;
  }

  .media-query-m {
    display: none;
  }
}
</style>
